/*
 * FleetOverviewCard
 *
 * Fleet-level summary ("12 active routes across 9 vessels") with the button
 * that shows/hides every vessel's active route on the map. Rendered on the
 * vessels level of the drill-down, between the toolbar and the list.
 */

import React from "react";
import { Box, Button, Typography } from "@mui/material";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import {
  PANEL_BUTTON_OUTLINED_SX,
  PANEL_BUTTON_SX,
  ROW_DESCRIPTION_SX,
} from "@/theme/panelStyles";
import { PANEL_DIVIDER, WW_BLUE } from "@/theme/tokens";
import { PLANNED_STATE_COLORS } from "@/utils/routeHelper";

export default function FleetOverviewCard({
  routeCount,
  vesselCount,
  active,
  loading,
  onToggle,
}) {
  const hasRoutes = (routeCount ?? 0) > 0;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        px: 0.5,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            flexShrink: 0,
            backgroundColor: hasRoutes
              ? PLANNED_STATE_COLORS.active
              : PANEL_DIVIDER,
          }}
        />
        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{ fontSize: "14px", fontWeight: 700, color: WW_BLUE, lineHeight: 1.2 }}
          >
            {loading && !hasRoutes
              ? "Loading active routes…"
              : `${routeCount ?? 0} active ${routeCount === 1 ? "route" : "routes"}`}
          </Typography>
          <Typography sx={{ ...ROW_DESCRIPTION_SX, fontSize: "12px" }}>
            {hasRoutes
              ? `across ${vesselCount} ${vesselCount === 1 ? "vessel" : "vessels"}`
              : "no vessel has an active route"}
          </Typography>
        </Box>
      </Box>
      <Button
        variant={active ? "outlined" : "contained"}
        size="small"
        disabled={!hasRoutes && !active}
        onClick={onToggle}
        startIcon={<MapOutlinedIcon sx={{ fontSize: 16 }} />}
        sx={active ? PANEL_BUTTON_OUTLINED_SX : PANEL_BUTTON_SX}
      >
        {active ? "Hide from map" : "Show on map"}
      </Button>
    </Box>
  );
}
